module.exports = __webpack_public_path__ + "static/laboheme2-fa2e7c83adbdd1d882611bba6adddc75.jpg";